import { render, staticRenderFns } from "./DeviceDetail.vue?vue&type=template&id=0ed65077&scoped=true&"
import script from "./DeviceDetail.vue?vue&type=script&lang=js&"
export * from "./DeviceDetail.vue?vue&type=script&lang=js&"
import style0 from "./DeviceDetail.vue?vue&type=style&index=0&id=0ed65077&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed65077",
  null
  
)

export default component.exports